import { render, staticRenderFns } from "./MetroidvaniaCrowdfunding.vue?vue&type=template&id=c02a37a2"
import script from "./MetroidvaniaCrowdfunding.vue?vue&type=script&lang=js"
export * from "./MetroidvaniaCrowdfunding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports